import { api } from "./apiClient";

const ownerQuery = (path, userId) => userId ? `${path}?userId=${encodeURIComponent(userId)}` : path;

export const promptApi = {
  providers: {
    list: (userId) => api.get(ownerQuery("/api/ai-providers", userId)),
    create: (data) => api.post("/api/ai-providers", data),
    update: (id, data) => api.put(`/api/ai-providers/${id}`, data),
    remove: (id) => api.delete(`/api/ai-providers/${id}`),
    test: (id) => api.post(`/api/ai-providers/${id}/test`),
    setDefault: (id) => api.put(`/api/ai-providers/${id}/default`),
  },
  assistants: {
    list: (userId) => api.get(ownerQuery("/api/ai-assistants", userId)),
    create: (data) => api.post("/api/ai-assistants", data),
    update: (id, data) => api.put(`/api/ai-assistants/${id}`, data),
    remove: (id) => api.delete(`/api/ai-assistants/${id}`),
  },
  flows: {
    list: (userId) => api.get(ownerQuery("/api/flows", userId)),
    get: (id) => api.get(`/api/flows/${id}`),
    create: (data) => api.post("/api/flows", data),
    update: (id, data) => api.put(`/api/flows/${id}`, data),
    remove: (id) => api.delete(`/api/flows/${id}`),
    run: (id, title, script = "", autoRun = false) => api.post(`/api/flows/${id}/runs`, { title, script, autoRun }),
  },
  scripts: {
    list: (userId) => api.get(ownerQuery("/api/scripts", userId)),
    get: (id) => api.get(`/api/scripts/${id}`),
    status: (id) => api.get(`/api/scripts/${id}/status`),
    remove: (id) => api.delete(`/api/scripts/${id}`),
    updateInput: (id, script) => api.put(`/api/scripts/${id}/input`, { script }),
    updateSteps: (id, data) => api.put(`/api/scripts/${id}/steps`, data),
    createStep: (id, data) => api.post(`/api/scripts/${id}/steps`, data),
    removeStep: (scriptId, stepId) => api.delete(`/api/scripts/${scriptId}/steps/${stepId}`),
    runAll: (id, data = {}) => api.post(`/api/scripts/${id}/run`, data),
    runStep: (scriptId, stepId, data = {}) => api.post(`/api/scripts/${scriptId}/steps/${stepId}/run`, data),
    runFlowStep: (scriptId, flowStepId) => api.post(`/api/scripts/${scriptId}/flow-steps/${flowStepId}/run`),
    rerunStep: (scriptId, stepId, data) => api.post(`/api/scripts/${scriptId}/steps/${stepId}/rerun`, data),
  },
};
